import React from "react";
import PropTypes from "prop-types";

import { classNames } from "@/helpers/classNames";

import MarkdownWrapper from "@/components/markdownWrapper.js";

function BlockBox({ title, description, children, ...other }) {
  if (!title) {
    return <></>;
  }

  return (
    <div className="overflow-hidden rounded-lg bg-white shadow" {...other}>
      <div className="border-b border-border-light-gray px-4 py-5 sm:px-6">
        <h2 className="text-lg font-medium leading-6 text-text-primary">
          {title}
        </h2>
        {description && (
          <MarkdownWrapper
            text={description}
            className={classNames(
              "mt-1 max-w-4xl text-sm text-text-secondary",
              "prose prose-headings:mt-4 prose-headings:font-medium prose-headings:text-text-secondary prose-h1:text-red-500 prose-h2:text-red-500"
            )}
            replaceParagraph={false}
            replaceComponents={{
              h1: "h3",
              h2: "h3",
              p: ({ children }) => {
                return <p className="whitespace-pre-wrap">{children}</p>;
              },
            }}
            blockHtml
          />
        )}
      </div>
      {children}
    </div>
  );
}

BlockBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default BlockBox;
